import { HttpParams } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { API_BASE_URL_SERVICE } from '../../../../../projects/kiene-core/src/lib/kiene-core.config';
import {
    DateTableColumn,
    KieneBooleanTableColumn,
    TextTableColumn,
} from '../../../components/kiene-table/table-column';
import { TableDescriptor } from '../../../components/kiene-table/table-descriptor';

@Component({
    selector: 'kiene-supplier-historie-dialog',
    templateUrl: './supplier-historie-dialog.component.html',
    styleUrls: ['./supplier-historie-dialog.component.scss'],
})
export class SupplierHistorieDialogComponent implements OnInit {
    tableDescriptor: TableDescriptor = new TableDescriptor();

    constructor(
        public dialogRef: MatDialogRef<SupplierHistorieDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private data,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
    ) {}

    ngOnInit(): void {
        const params = new HttpParams()
            .set('artikel_id', this.data.artikel_id)
            .set('lieferant_id', this.data.lieferant_id);

        this.tableDescriptor.headline = 'Lieferanten Einkauf Historie';
        this.tableDescriptor.uniqueIdentifier = 'Lieferanten-Einkauf-Historie';
        this.tableDescriptor.apiUrl = this.apiBaseUrl + 'artikel_lieferant_historie/';
        this.tableDescriptor.params = params;
        this.tableDescriptor.initialSortColumn = 'alh_id';
        this.tableDescriptor.showDetails = false;
        this.tableDescriptor.columns = [
            new TextTableColumn('alh_id', 'ID'),
            new TextTableColumn('artikel', 'Artikel'),
            new TextTableColumn('lieferant', 'Lieferant'),
            new TextTableColumn('einzelpreis', 'Einzelpreis (€)'),
            new TextTableColumn('rabatt', 'Rabatt (%)'),
            new TextTableColumn('skonto', 'Skonto (%)'),
            new TextTableColumn('zahlungsziel', 'Zahlungsziel (Tage)'),
            new KieneBooleanTableColumn('standard_lieferant', 'Standard Lieferant'),
            new DateTableColumn('editiert', 'Editiert'),
            new TextTableColumn('editiert_von', 'Editiert von'),
        ];

        this.tableDescriptor.permissionView = 1010;
    }
}
